import { IBasketOrderItemPrice, IOrderPriceGrace, IBasketOrderPriceDiscount } from "../order/types";


export default class BasketOrderItemPrice implements IBasketOrderItemPrice  {

  amount: number;
  installmentPrice: number | string;
  installmentWithIncludedDiscount: number;
  installments: number;
  discount: number;
  discounts: IBasketOrderPriceDiscount[];
  grace?: IOrderPriceGrace;
  paymentType: string;
  paymentMethod: string;
  participation?: number;
  isPriceMonthlyAnnuity?: boolean;
  isPaidOnCheckout?: boolean;
  constructor(
    amount: number,
    installmentPrice: number | string,
    installmentWithIncludedDiscount: number,
    installments: number,
    discount: number,
    discounts: IBasketOrderPriceDiscount[],
    grace: IOrderPriceGrace | undefined,
    paymentType: string,
    paymentMethod: string,
    participation: number | undefined,
    isPriceMonthlyAnnuity: boolean = false,
    isPaidOnCheckout: boolean = false
  ) {
    this.amount = amount;
    this.installmentWithIncludedDiscount = installmentWithIncludedDiscount;
    this.installmentPrice = installmentPrice;
    this.installments = installments;
    this.discount = discount;
    this.discounts = discounts;
    this.grace = grace;
    this.paymentType = paymentType;
    this.paymentMethod = paymentMethod;
    this.participation = participation;
    this.isPriceMonthlyAnnuity = isPriceMonthlyAnnuity;
    this.isPaidOnCheckout = isPaidOnCheckout;
  }

}
